import { message, Pagination, TableColumnsType, Typography } from "antd";
import { DataTable } from "~/Components";
import "../../../../index.css";

import ConfirmationModal from "@components/Modal/confirmation-modal";
import { TableDrawer } from "@components/TableDrawer/TableDrawer";
import { Icon } from "@iconify/react";
import { get as _get } from "lodash";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { magpCMSApi, post } from "~/Services";
import { magpHost } from "~/Utils";
import { decodeHTML, getFormattedDate } from "~/Utils/CommonUtils";
import { renderActionsColumn, renderPublishedColumn, renderUpdatedAtColumn } from "~/Utils/TableRenderFunction";
import { drilldownData, ModuleConfig } from "~/Utils/drilldownData";
import ActionDropdown, { TypeData } from "../../PASSENGER/ActionDropdown";
import { useAnnouncementDetails } from "./helper";

export const Announcements = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [id, setId] = useState<string | undefined>(selectedRowData?.id);
  const [searchValue, setSearchValue] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [data, setData] = useState<any>([]);
  const [selectedPublishedType, setselectedPublishedType] = useState<any>(undefined);
  const publishedType: TypeData[] = [
    {
      label: "Published",
      value: true,
    },
    {
      label: "Unpublished",
      value: false,
    },
  ];

  const [sortedData, setSortedData] = useState<any>([]);

  const currentPageData = sortedData.slice(currentPage * 10, (currentPage + 1) * 10);

  const [sortOrder, setSortOrder] = useState<string | undefined>();
  const [orderByName, setOrderByName] = useState<string>("field_tender_pre_heading_en");
  const {
    data: drilldown,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchDocument,
  } = useAnnouncementDetails(id || "");

  const { openToast } = useNotification();

  useEffect(() => {
    if (id) {
      refetchDocument();
    }
  }, [id]);

  useEffect(() => {
    if (query.get("activeTab") === "tender") {
      setselectedPublishedType("");
      setSearchValue("");
      setCurrentPage(0);
    }
  }, [query.get("activeTab")]);

  useEffect(() => {
    // Filter based on searchValue
    let filteredData = data;

    if (searchValue) {
      filteredData = filteredData.filter((item: any) => {
        return item.field_tender_pre_heading_en.toLowerCase().includes(searchValue.toLowerCase());
        // item.field_tender_calling_date.toLowerCase().includes(searchValue.toLowerCase()) ||
        // item.field_tender_closing_date.toLowerCase().includes(searchValue.toLowerCase()) ||
        // item.field_tender_created_at.toLowerCase().includes(searchValue.toLowerCase())
      });
    }

    // Filter based on selectedPublishedType
    if (selectedPublishedType !== undefined && selectedPublishedType !== "") {
      filteredData = filteredData.filter((item: any) => item.published === selectedPublishedType);
    }

    setSortedData(filteredData);
    setTotalRecords(filteredData.length);
    setCurrentPage(0);
  }, [data, searchValue, selectedPublishedType]);

  useEffect(() => {
    setId(selectedRowData?.id);
  }, [selectedRowData]);

  const renderDateColumn = (value: any) => {
    return <Typography.Text>{getFormattedDate(value)}</Typography.Text>;
  };

  const renderCreatedByColumn = (text: string) => {
    return text ? <div>{text}</div> : <div>Drupal Admin</div>;
  };

  const renderActionsColum = (value: any, row: any) => {
    return (
      <div className="flex gap-2">
        <Icon
          height={25}
          icon="iconamoon:eye"
          className="text-blue-600 border border-blue-600 rounded-full p-0.5"
          onClick={() => setDrawerVisible(true)}
        />
        <Icon
          height={25}
          icon="carbon:edit"
          className="text-orange-500 border border-orange-500 rounded-full p-0.5"
          onClick={() => {
            try {
              navigate(`/dedicated/magp/announcements/edit/${value.id}/cms`);
            } catch (err) {}
          }}
        />
        <Icon
          height={25}
          icon="material-symbols:delete-outline"
          className="text-red-600 border border-red-600 rounded-full p-0.5"
          onClick={() => setDeleteModalVisible(true)}
        />
      </div>
    );
  };

  const columns: TableColumnsType = [
    {
      title: "Tender Name",
      dataIndex: "field_tender_pre_heading_en",
      key: "field_tender_pre_heading_en",
      width: 200,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "field_tender_pre_heading_en"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "field_tender_pre_heading_en"
            ? "descend"
            : undefined,
      render: (text) => decodeHTML(text),
    },
    {
      title: "Tender Calling Date",
      dataIndex: "field_tender_calling_date",
      width: 120,
      key: "field_tender_calling_date",
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "field_tender_calling_date"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "field_tender_calling_date"
            ? "descend"
            : undefined,
    },
    {
      title: "Tender Closing Date",
      dataIndex: "field_tender_closing_date",
      key: "field_tender_closing_date",
      width: 120,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "field_tender_closing_date"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "field_tender_closing_date"
            ? "descend"
            : undefined,
    },
    {
      title: "Published",
      dataIndex: "published",
      key: "published",
      width: 100,
      render: renderPublishedColumn,
    },
    {
      title: "Created At",
      dataIndex: "field_tender_created_at",
      key: "field_tender_created_at",
      width: 90,
      render: (value: any) => renderDateColumn(value),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "field_tender_created_at"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "field_tender_created_at"
            ? "descend"
            : undefined,
    },
    {
      title: "Created By",
      dataIndex: "field_tender_created_by",
      key: "field_tender_created_by",
      width: 90,
      render: (text: string) => renderUpdatedAtColumn(text),
    },
    {
      title: "Updated At",
      dataIndex: "field_tender_updated_at",
      width: 90,
      key: "field_tender_updated_at",
      render: (value: any) => renderDateColumn(value),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "field_tender_updated_at"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "field_tender_updated_at"
            ? "descend"
            : undefined,
    },
    {
      title: "Updated By",
      width: 90,
      dataIndex: "field_tender_updated_by",
      key: "field_tender_updated_by",
    },
    {
      title: "Actions",
      key: "actions",
      width: 100,
      render: (record: any) =>
        renderActionsColumn(
          record,
          setSelectedRowData,
          setDrawerVisible,
          (e: any) => {
            e.preventDefault();
            navigate(`/dedicated/magp/announcements/edit/${record.id}/cms`);
          },
          undefined,
          setDeleteModalVisible,
          "announcement"
        ),
    },
  ];

  const handleApprove = async () => {
    try {
      message.success("Approved successfully!");
    } catch (error) {
      message.error("Failed to approve!");
    }
  };

  const handleReject = async () => {
    try {
      message.success("Rejected successfully!");
    } catch (error) {
      message.error("Failed to reject!");
    }
  };

  const actions = [
    { label: "Approve", onClick: handleApprove },
    { label: "Reject", onClick: handleReject },
  ];

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    if (apiUrl === "") return;

    let excludedKeys: any = [];
    // for (let key in data) {
    //   if (typeof data[key] === "string" && !excludedKeys.includes(key)) {
    //     data[key] = encodeHTML(data[key]);
    //   }
    // }

    const payload = {
      action: action,
      method: method,
      module: "ANNOUNCEMENT",
      subModule: "tender",
      type: "DEDICATED",
      application: "MAGP",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAGP",
          apiUrl: apiUrl,
        },
      ],
      payload: data,
      status: status,
    };

    post("/management/publish", payload)
      .then((response) => {
        openToast({
          content: "Data Sent for Review",
          type: "success",
        });
      })
      .catch((err: any) => {
        openToast({
          content: "Failed to send data",
          type: "error",
        });
      });
  };

  async function sendDeleteAnnouncementRequest(reviewNotes: string) {
    try {
      await onSubmit(
        selectedRowData,
        `${magpHost}/api/tender-creation/${selectedRowData?.id}`,
        "DELETE",
        "DELETE",
        "PENDING",
        reviewNotes
      );
    } catch (err) {}
  }

  useEffect(() => {
    const getRecords = () => {
      setIsLoading(true);
      let url = `/api/tender-details/all-fields`;
      magpCMSApi
        .get(url)
        .then((res: any) => {
          if (res && res.data) {
            let envelopes = res.data;
            setTotalRecords(envelopes.length);
            setData(envelopes);
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setData([]);
          setIsLoading(false);
        });
    };

    getRecords();
  }, []);

  const handleTableSort = (column: any, sortOrder: string) => {
    let order = "";

    if (sortOrder === "asc") {
      setSortOrder("desc");
      order = "desc";
    } else if (sortOrder === "desc") {
      setSortOrder(undefined);
      order = undefined;
    } else if (sortOrder === undefined) {
      setSortOrder("asc");
      order = "asc";
    }

    setOrderByName(column.dataIndex);

    const tempData = [...data];
    setSortedData(tempData.sort((a: any, b: any) => handleSort(a, b, order, column.dataIndex)));
    setCurrentPage(0);
  };

  return (
    <>
      <DataTable
        columns={columns.map((col) => ({
          ...col,
          onHeaderCell: (column: any) => (col.sorter ? { onClick: () => handleTableSort(col, sortOrder) } : {}),
        }))}
        className="table-clickable"
        tableData={
          currentPageData
            ? currentPageData?.map((d: any) => {
                return {
                  ...d,
                };
              })
            : []
        }
        isLoading={isLoading}
        exportFileName="CONTRACT"
        isPagination={true}
        onSearchChange={(searchText: string) => {
          setSearchValue(searchText);
          setCurrentPage(0);
        }}
        recordsPerPage={10}
        hideExport={true}
        multiSelect={false}
        isServerSearchApi={false}
        searchPlaceholderText={"Search by Tender Name"}
        onClick={(record) => {
          setSelectedRowData(record);
        }}
        additionalCTA={
          <div className="flex items-center space-x-2">
            <ActionDropdown
              value={selectedPublishedType}
              options={publishedType}
              onChange={setselectedPublishedType}
              placeholder="Select Published"
            />
          </div>
        }
      />
      <div className="pagination">
        <Pagination
          defaultCurrent={1}
          current={currentPage + 1}
          total={totalRecords}
          onChange={(curPage) => {
            setCurrentPage(curPage - 1);
          }}
          showSizeChanger={false}
        />
      </div>
      <TableDrawer
        title={
          <Typography.Title
            level={4}
            className={"!mb-0"}
          >
            Detailed View
          </Typography.Title>
        }
        visible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        // fields={announcementDrilldownData
        //   .map(({ fieldName, fieldValue, className, type }) => ({
        //     fieldName,
        //     fieldValue: decodeHTML(selectedRowData?.[fieldValue]) || "",
        //     className,
        //     type,
        //   }))
        //   .concat([
        //     {
        //       fieldName: "Published On",
        //       fieldValue: moment(selectedRowData?.createdAt).format("DD MMM yyyy"),
        //       className: "col-span-6",
        //       type: "text",
        //     },
        //   ])}
        fields={drilldownData[_get(drilldown, "subModule", "tender") as ModuleConfig]}
        data={drilldown}
      />

      <ConfirmationModal
        type="delete"
        open={deleteModalVisible}
        onClose={() => setDeleteModalVisible(false)}
        onSubmit={sendDeleteAnnouncementRequest}
      />
    </>
  );
};

function handleSort(a: any, b: any, order: string, sortBy: string) {
  if (sortBy.includes("date")) {
    const dateA = parseDateString(a[sortBy]);
    const dateB = parseDateString(b[sortBy]);

    if (order === "desc") {
      return dateA < dateB ? 1 : -1;
    } else if (order === "asc") {
      return dateA > dateB ? 1 : -1;
    } else {
      return 0;
    }
  }

  if (order === "desc") {
    return a[sortBy] < b[sortBy] ? 1 : -1;
  } else if (order === "asc") {
    return a[sortBy] > b[sortBy] ? 1 : -1;
  } else {
    return 0;
  }
}

function parseDateString(dateStr: string): Date {
  const [day, monthStr, year] = dateStr.split(" ");
  const month = new Date(Date.parse(monthStr + " 1, 2012")).getMonth();
  return new Date(Number(year), month, Number(day));
}
